import momentCache from "@/services/momentCache"

export default {
    unixDay(moment){
        return parseInt(moment.unix() / 60 / 60 / 24);
    },
    isForecastLocked(forecastDate){
        // Unlocked if it is after the end of the week
        // following the most recent thursday midnight (Friday 12am)
        let today = momentCache.createMoment().startOf('day');
        let daysOffsetToMostRecentFriday = 5 - today.day();
        if (daysOffsetToMostRecentFriday > 0){
            daysOffsetToMostRecentFriday -= 7;
        }
        let relativeDay = today.day() + daysOffsetToMostRecentFriday;
        let mostRecentThursday = today.day(relativeDay);

        let latestLockout = mostRecentThursday.clone()
            // Friday -> Following Sunday = +9 days
            .day(mostRecentThursday.day() + 9); 
        return momentCache.createMoment(forecastDate).startOf('day') <= latestLockout;
    },
    isAdjustedForecastLocked(forecastDate){
        // Locked if forecast is unlocked
        if(!this.isForecastLocked(forecastDate)){
            return true;
        }

        // Unlocked if the date is in the future
        let today = momentCache.createMoment().startOf('day');

        return momentCache.createMoment(forecastDate).startOf('day') <= today;
    },
    getAlertLevelColor(alertLevel){
        switch(alertLevel) {
            case 3:
                return "blue";
            case 2: 
                return "orange";
            case 1:
                return "red";
        }

        return null;
    },
    getDaysForWeek(selectedDate){
        let days = [];

        let startOfWeek = momentCache.createMoment(selectedDate).startOf('week');
        let endOfWeek = momentCache.createMoment(selectedDate).endOf('week');

        while(startOfWeek <= endOfWeek){
            days.push(startOfWeek.format('YYYY-MM-DD'));

            startOfWeek = startOfWeek.day(startOfWeek.day() + 1);
        }

        return days;
    },
    getForecastDays(days, forecasts){
        return days.map(x => {
            let forecast = forecasts.find(
                y => momentCache.getMoment(y.forecastDate).format('YYYY-MM-DD') == x
            );
            return {
                day: x,
                forecastValue: forecast == null || forecast.forecastValue == null ? "" : forecast.forecastValue,
                forecastValueLocked: this.isForecastLocked(x),
                adjustedValue: forecast == null || forecast.adjustedValue == null ? "" : forecast.adjustedValue,
                adjustedValueLocked: this.isAdjustedForecastLocked(x),
                actualValue: forecast == null || forecast.actualValue == null ? "" : forecast.actualValue
            }
        });
    },
    getWeekTotal(forecastDays){
        return forecastDays.reduce((a, v) => {
            if(v.actualValue != ""){
                return a + parseInt(v.actualValue);
            } else if(v.adjustedValue != "" && v.forecastValueLocked){
                return a + parseInt(v.adjustedValue);
            } else if(v.forecastValue != ""){
                return a + parseInt(v.forecastValue);
            }

            return a;
        }, 0);
    },
    getStartOfNextWeek(){
        return momentCache.createMoment()
            .startOf('week')
            .format('YYYY-MM-DD');
    },
    getEndOfNextWeek(){
        return momentCache.createMoment()
            .endOf('week')
            .format('YYYY-MM-DD')
    },
    calculateWeek(weekNumber, startingWeek) {
        if ((weekNumber + startingWeek - 1) > 52) {
            return (weekNumber + startingWeek - 1) - 52;
        }

        return weekNumber + startingWeek - 1;
    },
    calculateYear(weekNumber, startingWeek, startYear) {
        if ((weekNumber + startingWeek - 1) > 52) {
            return startYear + 1;
        }

        return startYear;
    },
    getFinancialDateFromWeekAndYear(week, year, financialYearCalendars) {
        var financialYearCalendar = financialYearCalendars.find(f=> f.financialYear == year);

        if (financialYearCalendar != null) {
            return momentCache.createMoment(financialYearCalendar.startDate).add(week - 1, 'week').format('YYYY-MM-DD');
        }

        return momentCache.createMoment().year(year).week(week).day('monday').format('YYYY-MM-DD');
    },    
    getFinancialStartDateFromProfile(profile, financialYearCalendars) {
            if (profile.BudgetValues && profile.StartWeek && profile.StartYear) {            
            return this.getFinancialDateFromWeekAndYear(profile.StartWeek, profile.StartYear, financialYearCalendars);
        }

        return null;
    },
    getFinancialEndDateFromProfile(profile, financialYearCalendars) {
        if (profile.BudgetValues && profile.StartWeek && profile.StartYear) {
            let weekNumber = Math.max(...profile.BudgetValues.map(b => b.BerriesForecastProfileWeekNumber));
            let start = momentCache.createMoment(this.getFinancialStartDateFromProfile(profile, financialYearCalendars));
            let end = start.add(weekNumber - 1, 'week');

            return this.getFinancialDateFromWeekAndYear(end.week(), end.year(), financialYearCalendars);
        }
        
        return null;
    },
    getFinancialWeek(weekStartDate, financialYearCalendars) {
        let financialYearCalendar = null;

        for (let index = 0; index < financialYearCalendars.length; index++) {
            const startDate = financialYearCalendars[index].startDate;

            if (momentCache.getMoment(weekStartDate).isSameOrAfter(momentCache.getMoment(startDate)) && index < financialYearCalendars.length - 1 && momentCache.getMoment(weekStartDate).isBefore(financialYearCalendars[index + 1].startDate)) {
                financialYearCalendar = financialYearCalendars[index];
                break;
            }

            if (momentCache.getMoment(weekStartDate).isSameOrAfter(momentCache.getMoment(startDate)) && index == financialYearCalendars.length - 1 && (momentCache.getMoment(weekStartDate).year() == momentCache.getMoment(startDate).year() || momentCache.getMoment(weekStartDate).year() == momentCache.getMoment(startDate).year() + 1)) {
                financialYearCalendar = financialYearCalendars[index];
                break;
            }
        }

        if(financialYearCalendar) {            
            return momentCache.getMoment(weekStartDate).diff(momentCache.getMoment(financialYearCalendar.startDate), 'week') + 1;
        } else {
            return "N/A";
        }
    },
    getFinancialYear(weekStartDate, financialYearCalendars) {
        let financialYearCalendar = null;

        for (let index = 0; index < financialYearCalendars.length; index++) {
            const startDate = financialYearCalendars[index].startDate;

            if (momentCache.getMoment(weekStartDate).isSameOrAfter(momentCache.getMoment(startDate)) && index < financialYearCalendars.length - 1 && momentCache.getMoment(weekStartDate).isBefore(financialYearCalendars[index + 1].startDate)) {
                financialYearCalendar = financialYearCalendars[index];
                break;
            }

            if (momentCache.getMoment(weekStartDate).isSameOrAfter(momentCache.getMoment(startDate)) && index == financialYearCalendars.length - 1 && (momentCache.getMoment(weekStartDate).year() == momentCache.getMoment(startDate).year() || momentCache.getMoment(weekStartDate).year() == momentCache.getMoment(startDate).year() + 1)) {
                financialYearCalendar = financialYearCalendars[index];
                break;
            }
        }

        if(financialYearCalendar) {            
            return financialYearCalendar.financialYear;
        } else {
            return momentCache.getMoment(weekStartDate).format("YYYY");
        }
    },
    calculateWeekTotal(week, items, forecasts) {
        var weekGrandTotal = 0;
        for(var i = 0; i < items.length; i ++) {
            var item = items[i];
            weekGrandTotal = weekGrandTotal + this.calculateCropVarietyWeekTotal(week, item, forecasts);
        }
    
        return weekGrandTotal;
    },
    calculateCropVarietyWeekTotal(week, item, forecasts) {
        let days = this.getDaysForWeek(week);
        var total = 0;
        days.forEach(day=> {
            total = total + this.calculateCropVarietyDayTotal(day, item, forecasts);
        })
        return total;
    },
    calculateDayTotal(day, items, forecasts) {
        var weekGrandTotal = 0;
        for(var i = 0; i < items.length; i ++) {
            var item = items[i];
            weekGrandTotal = weekGrandTotal + this.calculateCropVarietyDayTotal(day, item, forecasts);
        }
    
        return weekGrandTotal;
    },
    calculateCropVarietyDayTotal(day, item, forecasts) {
        let forecastDays = this.getForecastDays(
            [day], 
            forecasts.filter(
                y => {
                    return y.cropLocationId == item.variety.cropLocationId
                    && y.varietyId == item.variety.varietyId  
                }
            )
        );
        return this.getWeekTotal(forecastDays);
    },
    modifyForecastValue(day, newValue, forecastDays, allowZeroes, cropLocationId, varietyId) {
        let forecastDay = forecastDays.find(x => x.day == day);

        // Start without any changes
        let newForecastValue = forecastDay.forecastValue;
        let newAdjustedValue = forecastDay.adjustedValue;

        if (!forecastDay.forecastValueLocked) {
            // Update the forecast value
            newForecastValue = newValue;

            // If the forecast value was blank and it is now being set to 0
            // Leave it as blank
            if (newForecastValue === 0 && forecastDay.forecastValue === "" && !allowZeroes) {
                newForecastValue = "";
            }
        } else if (!forecastDay.adjustedValueLocked) {
            // Update the adjusted value
            newAdjustedValue = newValue;

            // If the adjusted value was blank and it is now being set to 0
            // Leave it as blank
            if (newAdjustedValue === 0 && forecastDay.adjustedValue === "" && !allowZeroes) {
                newAdjustedValue = "";
            }
        }

        // If the values haven't changed, no need to send a modification
        if (newForecastValue === forecastDay.forecastValue
            && newAdjustedValue === forecastDay.adjustedValue) {
            return null;
        }

        // Return a modification
        return {
            forecastDate: day,
            forecastValue: newForecastValue === "" ? null : newForecastValue,
            adjustedValue: newAdjustedValue === "" ? null : newAdjustedValue,
            cropLocationId: cropLocationId,
            varietyId: varietyId
        };
    },
}
